//
//
//
//
//
//
//
//

import utils from '../../utils/utils';

export default {
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
    // 预留属性
    text: String,
  },
  data(){
    return {
      svgaPlayer: null,
    };
  },
  watch: {
    show (val) {
      this.$emit('update:show', val);
    }
  },
  mounted(){
    // 渲染loading动画
    setTimeout(() => {
      this.svgaPlayer = utils.transformSVGA('#loadingSvga', '/m/static/animate-source/modal-loading.svga');
    }, 100);
  },
}



// WEBPACK FOOTER //
// ./src/components/BGLoading/BGLoading.vue